import React from 'react';
import { HEADING } from '../../../../components/heading/constants/constants';
import Heading from '../../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import Icons from '../../../../components/icons/Icons';
import styles from './PreLoginLeftColumn.styles';

export default function PreLoginLeftColumn() {
    return (
        <>
            <div>
                <div>
                    <Icons familyName='vec' iconName={VEC_ICON_NAME.TAX1099_LOGO} style={styles.logo} />
                </div>
                <div style={styles.imageSection}>
                    <div>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.PRE_LOGIN_IMAGE} />
                    </div>
                    <div style={styles.sectionLabelContainer}>
                        <Heading type={HEADING.H1} customStyle={styles.sectionLabel} >
                            Simplified eFiling With Tax1099!
                        </Heading>
                    </div>
                    <div style={styles.bottomRow}>
                        <div style={styles.featureDiv}>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON1} />
                            <span style={styles.featureText}>
                                Secured & easy, compliance <br />eFiling software
                            </span>
                        </div>
                        <div style={styles.featureDiv}>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON2} />
                            <span style={styles.featureText}>
                            Easy to create, verify, <br />& eFile 1099 forms
                            </span>
                        </div>
                        <div style={styles.featureDiv}>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON3} />
                            <span style={styles.featureText}>
                                Get faster eFile <br /> acceptance from IRS 
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}